import { signupFormWithAnalyticsSchema } from "@redotech/redo-marketing-common/signup-form/signup-form-schema";
import * as z from "zod";

export const getSignupFormsByTeamId = {
  name: "getSignupFormsByTeamId" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(signupFormWithAnalyticsSchema),
};
